import { sentryQabConfig } from './sentryConfig';

export const sentryConfigBrochureware = {
  ...sentryQabConfig,
  dsn: 'https://29acb73edeef614335cd4bec4437a97d@o207017.ingest.sentry.io/4506110032740352',
};
